module.exports = __webpack_public_path__ + "img/youtube.f90ca248.png";